// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0e6b7cb","455":"4b3aeaf8","977":"3f8a9ef0"}[chunkId] + ".chunk.js";
};